/**
 * New strings of the "Enregistrer" page, FR and EN. Everything that already
 * had a key in translations.ts keeps using it (t.startRecording, t.next...).
 */
export const speakContributeCopy = {
  fr: {
    record: "Enregistrer",
    resumeTitle: "Reprise de votre session",
    resumeBody: "Elle reprend toute seule dès que les phrases sont chargées.",
    stop: "Arrêter",
    redo: "Refaire",
    send: "Envoyer",
    finish: "Terminer",
    stateIdle: "Appuyez sur Enregistrer, lisez la phrase, puis arrêtez.",
    stateRecording: "Enregistrement en cours",
    statePaused: "En pause, le temps de pause n'est pas enregistré",
    statePreview: "Réécoutez votre enregistrement avant de l'envoyer.",
    stateDone: "Cette phrase est déjà enregistrée. Passez à la suivante.",
    doneDescription: "Il n'y a plus de phrase à lire dans cette langue pour le moment. Merci pour vos enregistrements.",
    doneRecorded: "Phrases enregistrées",
    doneBack: "Revenir à la session",
    reRecordTitle: "Réenregistrer cette phrase",
    editPhrase: "Modifier la phrase",
  },
  en: {
    resumeTitle: "Resuming your session",
    resumeBody: "It picks up on its own once the sentences are loaded.",
    record: "Record",
    stop: "Stop",
    redo: "Redo",
    send: "Send",
    finish: "Finish",
    stateIdle: "Press Record, read the sentence, then stop.",
    stateRecording: "Recording",
    statePaused: "Paused, the pause is not recorded",
    statePreview: "Listen back to your recording before sending it.",
    stateDone: "This sentence is already recorded. Move to the next one.",
    doneDescription: "There are no more sentences to read in this language for now. Thank you for your recordings.",
    doneRecorded: "Sentences recorded",
    doneBack: "Back to the session",
    reRecordTitle: "Record this sentence again",
    editPhrase: "Edit the sentence",
  },
} as const;

export type SpeakContributeCopy = { [K in keyof (typeof speakContributeCopy)["fr"]]: string };
